<app-header></app-header>

<ion-content scrollbar class="ion-content-padding-top-0">
  <app-list-header [hideHeader]="true" [hideSeparator]="true">
    <ng-container top>
      <app-search-bar
        #searchBar
        [permissionEdit]="buildingAddRole"
        addLink="./add"
        buttonAddLabel="{{ 'BUILDING.ADD_BUILDING' | translate}}"
        (searchEvent)="onChangeSearch()"
      >
      </app-search-bar>
    </ng-container>
  </app-list-header>

  <ion-fab
    *ngIf="p.renderMobile && buildingAddRole"
    vertical="bottom"
    horizontal="end"
    slot="fixed"
  >
    <ion-fab-button routerLink="./add">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <app-pagination-client-side
    [columns]="columnsDefinition"
    [ngClass]="{'height-0': showLoader}"
    [componentRef]="componentRef"
    (rowsLoaderReady)="rowsLoaderServiceReady($event)"
    [options]="options"
    (refreshRequest)="loadBuildings()"
  >
  </app-pagination-client-side>

  <div class="spin" *ngIf="showLoader">
    <app-loading-sti></app-loading-sti>
  </div>

</ion-content>
